module.exports = __webpack_public_path__ + "static/st-4-221e542cb80a99580efd101e2aec4b55.jpg";